import styled from "styled-components";

const CenteredContainer = styled.div`
  width: 100%;
  max-width: 768px;
  padding: 2.5em;
  box-sizing: border-box;
`;

export default CenteredContainer;
